<template>
  <span v-if="!serviceIsDelivery">*</span>
</template>

<script>
export default {
  name: "OrderAsterisk",
  computed: {
    serviceIsDelivery() {
      return this.$store.getters["orders/serviceIsDelivery"] === "DELIVERY";
    },
  },
};
</script>
